import {Switch} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {i18n2} from 'features/i18n/i18n';
import {Field} from 'formik';
import {TextField} from 'formik-material-ui';
import React from 'react';

const Groups = ({formikProps}) => {
  return (
    <Grid>
      <Grid container spacing={2}>
        <Grid item md={3} xs={12}>
          <Field
            component={Switch}
            name="validateGroup"
            checked={formikProps.values['validateGroup']}
            label={i18n2._('Validar grupo')}
            onChange={(e) => {
              formikProps.setFieldValue('validateGroup', e.target.checked);
            }}
            disabled={!formikProps.values.validateDomain}
          />
          <p style={{display: 'inline'}}>{i18n2._('Validar grupo')}</p>
        </Grid>
        <Grid item md={6} xs={12}>
          <Field
            name="hseGroup"
            component={TextField}
            label={i18n2._('Grupo HSE')}
            fullWidth
            variant="outlined"
            disabled={!formikProps.values.validateGroup}
            required={formikProps.values.validateDomain ? true : false}
            size={'small'}
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        style={{marginLeft: '24.2%', marginTop: '3px'}}
      >
        <Grid item md={6} xs={12} style={{marginLeft: '0.5%'}}>
          <Field
            name="qaGroup"
            component={TextField}
            label={i18n2._('Grupo QA')}
            fullWidth
            variant="outlined"
            disabled={!formikProps.values.validateGroup}
            required={formikProps.values.validateDomain ? true : false}
            size={'small'}
          />
        </Grid>
        <Grid item md={6} xs={12} style={{marginLeft: '0.5%'}}>
          <Field
            name="itpsGroup"
            component={TextField}
            label={i18n2._('Grupo ITPS')}
            fullWidth
            variant="outlined"
            disabled={!formikProps.values.validateGroup}
            required={formikProps.values.validateDomain ? true : false}
            size={'small'}
          />
        </Grid>
        <Grid item md={6} xs={12} style={{marginLeft: '0.5%'}}>
          <Field
            name="collaboratorGroup"
            component={TextField}
            label={i18n2._('Grupo colaborador')}
            fullWidth
            variant="outlined"
            disabled={!formikProps.values.validateGroup}
            required={formikProps.values.validateDomain ? true : false}
            size={'small'}
          />
        </Grid>
        <Grid item md={6} xs={12} style={{marginLeft: '0.5%'}}>
          <Field
            name="trainerGroup"
            component={TextField}
            label={i18n2._('Grupo capacitador')}
            fullWidth
            variant="outlined"
            disabled={!formikProps.values.validateGroup}
            required={formikProps.values.validateDomain ? true : false}
            size={'small'}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Groups;
